import { useState } from 'react'
import { toast } from 'sonner'
import { apiErrorMessage } from '@/i18n'
import { isApiError } from '@/lib/api/errors'
import { VaultUnlockModal } from './VaultUnlockModal'

/** İşlemi çalıştırır; vault kapalıysa (VAULT_LOCKED) PIN ister ve bir kez yeniden dener. Diğer hatalar bildirim olur. */
export function useVaultRetry() {
  const [pending, setPending] = useState<(() => Promise<void>) | null>(null)
  const run = async (action: () => Promise<void>, retried = false) => {
    try {
      await action()
    } catch (e) {
      if (!retried && isApiError(e) && e.code === 'VAULT_LOCKED') setPending(() => action)
      else toast.error(apiErrorMessage(e))
    }
  }
  const modal = pending ? (
    <VaultUnlockModal
      onClose={() => setPending(null)}
      onUnlocked={() => {
        setPending(null)
        void run(pending, true)
      }}
    />
  ) : null
  return { run, modal }
}
